module.exports = __webpack_public_path__ + "static/df.7e44dd87.svg";